var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { spacing } from '../../theme/spacing';
var IconContainer = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  margin-right: ", ";\n"], ["\n  display: inline-block;\n  margin-right: ", ";\n"])), spacing.m);
var ContentContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: ", ";\n"], ["\n  display: ", ";\n"])), function (props) { return (props.open ? 'block' : 'none'); });
var TriggerText = {
    text: {
        textDecoration: 'underline',
    },
};
export { IconContainer, ContentContainer, TriggerText };
var templateObject_1, templateObject_2;
